import { Link } from 'react-router-dom';
import { ArrowRight, ArrowUpRight, MapPin } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

export const TourPreview = ({ tourDates }) => {
    if (!tourDates || tourDates.length === 0) return null;

    return (
        <section
            data-testid="tour-preview-section"
            className="py-24 md:py-32 px-6 md:px-12 lg:px-24"
        >
            <div className="max-w-7xl mx-auto">
                <div className="flex justify-between items-end mb-12">
                    <div>
                        <p className="font-mono text-xs text-brand-primary uppercase tracking-widest mb-4">ON THE ROAD</p>
                        <h2 className="font-syne font-bold text-4xl md:text-5xl text-white tracking-tight">
                            UPCOMING SHOWS
                        </h2>
                    </div>
                    <Link to="/tour" className="hidden md:block">
                        <Button
                            variant="ghost"
                            className="text-slate-400 hover:text-white uppercase tracking-widest"
                        >
                            ALL DATES <ArrowRight className="w-4 h-4 ml-2" />
                        </Button>
                    </Link>
                </div>

                <div className="space-y-4">
                    {tourDates.map((date) => (
                        <div
                            key={date.id}
                            data-testid={`tour-date-${date.id}`}
                            className="group flex flex-col md:flex-row md:items-center justify-between p-6 bg-brand-surface border border-white/5 hover:border-white/20 transition-colors duration-500"
                        >
                            <div className="flex items-center gap-6 mb-4 md:mb-0">
                                <div className="text-center md:text-left min-w-[80px]">
                                    <p className="font-syne font-bold text-2xl text-white">
                                        {new Date(date.date).getDate()}
                                    </p>
                                    <p className="font-mono text-xs text-slate-500 uppercase">
                                        {new Date(date.date).toLocaleDateString('en-US', { month: 'short' })}
                                    </p>
                                </div>
                                <div>
                                    <h3 className="font-syne font-bold text-white text-lg">{date.venue}</h3>
                                    <p className="font-space text-slate-400 text-sm flex items-center gap-2">
                                        <MapPin className="w-3 h-3" /> {date.city}
                                    </p>
                                </div>
                            </div>
                            {date.sold_out ? (
                                <Badge className="bg-white/10 text-slate-400 uppercase tracking-widest">
                                    Sold Out
                                </Badge>
                            ) : (
                                <a
                                    href={date.ticket_url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid={`tickets-${date.id}`}
                                    className="font-space text-sm text-white uppercase tracking-widest flex items-center gap-2 hover:text-brand-accent transition-colors"
                                >
                                    TICKETS <ArrowUpRight className="w-4 h-4" />
                                </a>
                            )}
                        </div>
                    ))}
                </div>

                <Link to="/tour" className="md:hidden mt-8 block">
                    <Button
                        variant="outline"
                        className="w-full bg-transparent border border-white/20 text-white hover:bg-white/10 rounded-none py-4 uppercase tracking-widest"
                    >
                        ALL TOUR DATES <ArrowRight className="w-4 h-4 ml-2" />
                    </Button>
                </Link>
            </div>
        </section>
    );
};
